import { render, staticRenderFns } from "./ListCompletedTask.vue?vue&type=template&id=8d64e642"
import script from "./ListCompletedTask.vue?vue&type=script&lang=js"
export * from "./ListCompletedTask.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./ListCompletedTask.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8d64e642')) {
      api.createRecord('8d64e642', component.options)
    } else {
      api.reload('8d64e642', component.options)
    }
    module.hot.accept("./ListCompletedTask.vue?vue&type=template&id=8d64e642", function () {
      api.rerender('8d64e642', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tasks/views/ListCompletedTask.vue"
export default component.exports